export default __webpack_public_path__ + "static/media/mad-ape-003.8bd5c48a.svg";